import { Box, SxProps, Theme } from '@mui/material';
import { UseTableCellProps } from 'react-table';
import { CustomerContractInventoryGridItem } from 'shared/types/customerManagement';
import { FormattedNumber } from 'shared/controls';
import { TableTypography } from 'shared/tables/columns/table-typography';

const gridStyles: SxProps<Theme> = {
  display: 'grid',
};

export function NumberColumn(props: UseTableCellProps<CustomerContractInventoryGridItem>) {
  const { value } = props;
  return (
    <Box sx={gridStyles}>
      <TableTypography>
        <FormattedNumber value={value} />
      </TableTypography>
    </Box>
  );
}
